import app from 'flarum/forum/app';

export function isWeChat() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua && (/MicroMessenger/i.test(ua) || /miniProgram/i.test(ua)) || (window as any).__wxjs_environment === 'miniprogram') {
    return true;
  } else {
    return false;
  }
}

/**
 * 根据 API 返回的 ret 错误码获取翻译后的错误信息
 * @param ret 错误码
 * @param msg API 返回的原始错误消息，当没有对应翻译时作为备选显示
 * @returns 翻译后的错误信息，或 API 返回的 msg
 */
export function getErrorMessage(ret: number | string, msg?: string): string {
  const code = String(ret);
  const translationKey = `laya-auth.forum.error.${code}`;
  const translated = app.translator.trans(translationKey);

  // app.translator.trans() 可能返回数组或字符串，需要处理
  const translatedStr = Array.isArray(translated) ? translated.join('') : String(translated);

  // 如果翻译存在且不是原始的 key，返回翻译
  if (translatedStr && translatedStr !== translationKey) {
    return translatedStr;
  }

  // 如果有 API 返回的 msg，使用 msg
  if (msg) {
    return msg;
  }

  // 否则返回未知错误
  const unknownMsg = app.translator.trans('laya-auth.forum.error.unknown');
  const unknownStr = Array.isArray(unknownMsg) ? unknownMsg.join('') : String(unknownMsg);
  return unknownStr || `Unknown error (${ret})`;
}
